import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InventoryOutputDetailTableModel } from 'src/app/models/tables/inventory/inventory-output-detail-table.model';
import { InventoryOutputTableModel } from 'src/app/models/tables/inventory/inventory-output-table.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { SalesRemissionDetailService } from 'src/app/services/inventory/sales-remission-detail.service';
import { SalesRemissionService } from 'src/app/services/inventory/sales-remission.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-sales-remission',
  templateUrl: './sales-remission.component.html',
  styleUrls: ['./sales-remission.component.scss'],
  standalone: false
})
export class SalesRemissionComponent implements OnInit {

  activeTabIndex = 0;
  ascendant: boolean = true;
  columnSort: string | null = null;
  filters: ColumnResponseModel[] = [];
  generalData: PagedResponseModel<InventoryOutputTableModel> =
    new PagedResponseModel<InventoryOutputTableModel>();
  generalHeader: ColumnResponseModel[] = [];
  detailData: PagedResponseModel<InventoryOutputDetailTableModel> =
    new PagedResponseModel<InventoryOutputDetailTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  isOpened: string | undefined = undefined;
  limit: number = 10;
  nameWindow: string = 'Remisiones de Venta';
  page: number = 1;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    },
  ];
  url: string = '';

  constructor(private headerService: HeaderService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private salesRemissionService: SalesRemissionService,
    private salesRemissionDetailService: SalesRemissionDetailService,
    private windowService: WindowService,) {
    this.getPermission();
  }

  async ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    const filters = localStorage.getItem('sales-remission');
    if (filters) this.filters = JSON.parse(filters);
    await Promise.all([
      this.getColumnsForGeneralConsultation(),
      this.getAllSalesRemissionsWithPagination(),
    ]);
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  createNewRegister() {
    if (this.permissionUpdatable) {
      this.router.navigate(['/sales-remission/register']);
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para crear remisiones de venta. Comuníquese con el administrador del sistema.'
      );
    }
  }

  async exportDetailsConsultation() {
    try {
      const response = await firstValueFrom(this.salesRemissionDetailService.exportDetailConsultation(
        this.filters, this.columnSort, this.ascendant
      ));
      const blob = response;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Remisión de Venta Detalles.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al exportar el detalle de las remisiones de venta.', error);
    }
  }

  async exportGeneralConsultation() {
    try {
      const response = await firstValueFrom(this.salesRemissionService.exportGeneralConsultation(
        this.filters, this.columnSort, this.ascendant
      ));
      const blob = response;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Remisiones de Venta.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al exportar remisiones de venta.', error);
    }
  }

  async getAllSalesRemissionsWithPagination() {
    try {
      this.generalData = await firstValueFrom(this.salesRemissionService.getAllSalesRemissionsWithPagination(
        this.page, this.limit, this.columnSort, this.ascendant, this.filters
      ));
    } catch (error) {
      console.error('Error al buscar las remisiones de venta.', error);
    }
  }

  async getAllSalesRemissionDetailsWithPagination() {
    try {
      this.detailData = await firstValueFrom(this.salesRemissionDetailService.getAllSalesRemissionDetailsWithPagination(
        this.page, this.limit, this.columnSort, this.ascendant, this.filters
      ));
    } catch (error) {
      console.error('Error al buscar los detalles de las remisiones de venta.', error);
    }
  }

  async getColumnsForDetailsConsultation() {
    try {
      if (this.detailHeader.length === 0) {
        this.detailHeader = await firstValueFrom(this.salesRemissionDetailService.getColumnsForDetailConsultation());
      }
    } catch (error) {
      console.error('Error al buscar columnas para la consulta de detalles.', error);
    }
  }

  async getColumnsForGeneralConsultation() {
    try {
      if (this.generalHeader.length === 0) {
        this.generalHeader = await firstValueFrom(this.salesRemissionService.getColumnsForGeneralConsultation());
      }
    } catch (error) {
      console.error('Error al buscar columnas para la consulta general.', error);
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await this.getPermissionProfileByUrl();
  }

  async getPermissionProfileByUrl() {
    try {
      const response = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      this.permissionUpdatable = response;
    } catch (error) {
      console.error('Error al obtener permiso por URL.', error);
    }
  }

  goToHome(event: Event) {
    event.preventDefault();
    this.router.navigate(['/main']);
  }

  public async handleTabChange(tabIndex: number) {
    this.generalHeader.length = this.generalHeader.length === 1 ? 0 : this.generalHeader.length;
    this.detailHeader.length = this.detailHeader.length === 1 ? 0 : this.detailHeader.length;
    if (this.activeTabIndex === tabIndex) return;
    this.page = 1;
    this.limit = 10;
    this.activeTabIndex = tabIndex;
    switch (this.activeTabIndex) {
      case 0:
        await Promise.all([
          this.getColumnsForGeneralConsultation(),
          this.getAllSalesRemissionsWithPagination()
        ]);
        this.generalData = {
          ...this.generalData,
          currentPage: 1,
          pageSize: 10
        };
        break;
      case 1:
        await Promise.all([
          this.getColumnsForDetailsConsultation(),
          this.getAllSalesRemissionDetailsWithPagination()
        ]);
        this.detailData = {
          ...this.detailData,
          currentPage: 1,
          pageSize: 10
        };
        break;
    }
  }

  onAction(event: { action: string, item?: any, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      this.router.navigate([`/sales-remission/register/${event.item.id}`]);
    }
  }

  async onExport() {
    switch (this.activeTabIndex) {
      case 0:
        await this.exportGeneralConsultation();
        break;
      case 1:
        await this.exportDetailsConsultation();
        break;
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    switch (this.activeTabIndex) {
      case 0:
        await this.getAllSalesRemissionsWithPagination()
        break;
      case 1:
        await this.getAllSalesRemissionDetailsWithPagination()
        break;
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }
}
